import {
  IonGrid,
  IonRow,
  IonCol,
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonImg,
} from '@ionic/react';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  FOOTER_LISTS,
  SPORTS_FOOTER_LISTS,
  CASINO_FOOTER_LISTS,
} from '../../constants/FooterView';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import './Footer.scss';
import { RootState } from '../../models/RootState';
import SocialMedia from '../SocialMedia/SocialMedia';
import Copyright from '../Copyright/CopyrightV2';
import titleImg from '../../assets/images/brand/title.png';
import betfairImg from '../../assets/images/footer/betfair.svg';
import CopyrightV2 from '../Copyright/CopyrightV2';

type StoreProps = {
  allowedConfig: number;
  langData:any;
};

const Footer: React.FC<StoreProps> = (props) => {
  const { allowedConfig ,langData} = props;

  return (
    <IonGrid class="footer-grid">
      <CopyrightV2 loggedIn={false} />
    </IonGrid>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
    langData:state.common.langData
  };
};

export default connect(mapStateToProps, null)(Footer);
